import { MessageCircle, ArrowRight, Plane, ShieldCheck } from "lucide-react";
import { HERO_IMAGE, WHATSAPP_URL } from "@/lib/constants";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-[120px] pb-20 lg:pt-[140px] lg:pb-24 bg-[var(--buzas-bg)] overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute -top-40 -right-40 w-[520px] h-[520px] rounded-full opacity-[0.07]"
        style={{
          background:
            "radial-gradient(closest-side, var(--buzas-navy), transparent)",
        }}
      />

      <div className="container-buzas relative">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* LEFT — 7 cols */}
          <div className="lg:col-span-7">
            <span
              data-testid="hero-eyebrow"
              className="eyebrow-pill anim-fade-up"
            >
              <Plane size={14} className="text-[var(--buzas-red)]" />
              Peças metálicas para linha aeroviária
            </span>

            {/* H1 — Solução + nicho */}
            <h1
              data-testid="hero-headline"
              className="font-display text-[2.2rem] sm:text-[2.6rem] lg:text-[3rem] xl:text-[3.4rem] leading-[1.06] tracking-tight anim-fade-up delay-100"
              style={{
                marginTop: "24px",
                marginBottom: "16px",
                fontWeight: 700,
                maxWidth: "20ch",
              }}
            >
              Soluções para projetos de peças metálicas que atendem a{" "}
              <span
                className="text-[var(--buzas-red)]"
                style={{
                  fontWeight: 900,
                  fontStretch: "normal",
                  letterSpacing: "-0.025em",
                }}
              >
                linha aeroviária.
              </span>
            </h1>

            {/* H2 — Solução */}
            <h2
              data-testid="hero-subheadline"
              className="font-display text-[1.35rem] sm:text-2xl lg:text-[1.75rem] leading-[1.25] tracking-tight anim-fade-up delay-200"
              style={{
                color: "rgba(26, 43, 86, 0.80)",
                fontWeight: 600,
                marginBottom: "32px",
                maxWidth: "36ch",
              }}
            >
              Tenha peças sob medida com precisão industrial e entrega
              confiável.
            </h2>

            <div className="flex flex-wrap gap-4 anim-fade-up delay-400">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noreferrer"
                data-testid="hero-cta-whatsapp"
                className="btn-primary"
              >
                <MessageCircle size={18} />
                Falar no WhatsApp
              </a>
              <a
                href="#cta"
                data-testid="hero-cta-quote"
                className="btn-outline"
              >
                Solicitar orçamento
                <ArrowRight size={18} />
              </a>
            </div>

            <p
              data-testid="hero-microcopy"
              className="mt-6 text-sm text-[var(--buzas-muted)] anim-fade-up delay-500"
            >
              Precisão, segurança e prazo para manter sua operação ativa.
            </p>
          </div>

          {/* RIGHT — 5 cols: macro image */}
          <div className="lg:col-span-5 relative anim-fade-up delay-300">
            <div
              className="relative overflow-hidden bg-[var(--buzas-navy)] aspect-[4/5] lg:aspect-[5/6]"
              style={{
                borderTopLeftRadius: "28px",
                borderTopRightRadius: "28px",
                borderBottomLeftRadius: "28px",
                borderBottomRightRadius: "120px",
              }}
            >
              <img
                src={HERO_IMAGE}
                alt="Escada de embarque metálica encostada em aeronave — peças sob projeto Buzas"
                className="absolute inset-0 w-full h-full object-cover"
                data-testid="hero-image"
                style={{
                  filter: "grayscale(0.25) contrast(1.08) brightness(0.92)",
                }}
              />
              <div
                aria-hidden
                className="absolute inset-0"
                style={{
                  background:
                    "linear-gradient(180deg, rgba(26,43,86,0.35) 0%, rgba(26,43,86,0.55) 60%, rgba(26,43,86,0.85) 100%)",
                  mixBlendMode: "multiply",
                }}
              />
              <div
                aria-hidden
                className="absolute inset-0 bg-gradient-to-t from-[var(--buzas-navy)]/60 via-transparent to-transparent"
              />

              <div className="absolute top-5 right-5 bg-white rounded-full px-4 py-2 text-xs font-bold text-[var(--buzas-navy)] shadow-lg flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-[var(--buzas-red)]" />
                30+ anos de engenharia
              </div>

              <div
                data-testid="hero-floating-card"
                className="absolute left-5 right-5 bottom-5 bg-white rounded-xl p-5 shadow-[0_20px_50px_-12px_rgba(26,43,86,0.35)] border border-[var(--buzas-border)] flex items-center gap-4"
              >
                <span className="inline-flex items-center justify-center w-11 h-11 rounded-lg bg-[rgba(26,43,86,0.06)] text-[var(--buzas-navy)]">
                  <ShieldCheck size={20} />
                </span>
                <div>
                  <p className="text-[11px] uppercase tracking-[0.18em] font-bold text-[var(--buzas-red)]">
                    Controle técnico
                  </p>
                  <p className="mt-1 text-[15px] font-bold text-[var(--buzas-navy)] leading-tight">
                    Peças sob projeto, aprovadas para operação
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
